import { render } from "./TermsAndConditions.vue?vue&type=template&id=721bb67c&ts=true"
import script from "./TermsAndConditions.vue?vue&type=script&lang=ts"
export * from "./TermsAndConditions.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__